import { createBrowserHistory, History } from "history";

const history: History = createBrowserHistory();

history.location = {
  ...history.location,
  state: { modal: false, scroll: false },
};

const reloadApp = () => {
  // Hard reload the page if new build released
  if ((window as any).swUpdate) {
    window.location.href = window.location.href;
  }
};

/* istanbul ignore next */
const unlisten = history.listen(() => {
  reloadApp();
  history.location = {
    ...history.location,
    state: history.location.state || {},
  };
});
unlisten();
export default history;
